module.exports = __webpack_public_path__ + "media/images/countryrect/ps-d55f34b2baacbd9322cff2e21c4d3092.svg";